import { DataTableSelectType, TableRequiredFields } from '@repo/ui/data-table'

import { t } from '../../../../locale/utils'

export type DeleteMessage<TData> = {
  name: string
  attributeName: keyof TData
  deleteOne?: string | ((data: TData) => string)
  deleteMany?: string | ((data: TData[]) => string)
  deleteAll?: string
}

type Options<TData> = {
  deleteMessage?: string | DeleteMessage<TData>
}

export function getDeleteMessage<TData extends TableRequiredFields>(
  data: DataTableSelectType<TData>,
  { deleteMessage }: Options<TData>
): string | undefined {
  if (!deleteMessage) return undefined
  if (typeof deleteMessage === 'string') return deleteMessage

  // if data is selected all
  if (!Array.isArray(data) || data.length === 0)
    return (
      deleteMessage?.deleteAll ??
      t('dynamic.data.table.delete.all.label', { message: deleteMessage.name })
    )

  // if we only have one element
  if (data.length === 1) {
    if (typeof deleteMessage.deleteOne === 'function') return deleteMessage.deleteOne(data[0])
    return (
      deleteMessage?.deleteOne ??
      t('dynamic.data.table.delete.one.label', {
        message: `${deleteMessage.name} "${data[0][deleteMessage.attributeName]}"`
      })
    )
  }

  // if we have more than one seleted element
  if (typeof deleteMessage.deleteMany === 'function') return deleteMessage.deleteMany(data)
  return (
    deleteMessage?.deleteMany ??
    t('dynamic.data.table.delete.many.label', {
      message: `${deleteMessage?.name} "${data
        .map((selectedRow) => selectedRow[deleteMessage?.attributeName])
        .join('", "')}"`
    })
  )
}
